<script>
import { Btn, Dropdown } from "uiv";
import { ShareNetwork } from "vue-social-sharing";

export default {
  name: "ShareButton",
  components: { Btn, Dropdown, ShareNetwork },
  props: {
    habilitado: { type: Boolean, default: true },
    size: { type: String, default: "md" },
    // Network properties
    // https://github.com/nicolasbeauvais/vue-social-sharing?tab=readme-ov-file#network-properties
    url: { type: String, default: false }, // URL to share.
    title: { type: String, default: "" }, // Sharing title (if available).
    description: { type: String, default: "" }, // Sharing description (if available).
    quote: { type: String, default: "" }, // Facebook quote (Facebook only).
    hashtags: { type: String, default: "" }, // A list of comma-separated hashtags (Twitter and Facebook).
    twitterUser: { type: String, default: "" }, // Twitter user (Twitter only).
  },
  data() {
    return {
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fa-facebook-f",
          color: "#1877f2",
        },
        {
          network: "telegram",
          name: "Telegram",
          icon: "fa-telegram",
          color: "#0088cc",
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fa-twitter",
          color: "#1da1f2",
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fa-whatsapp",
          color: "#25d366",
        },
      ],
    };
  },
};
</script>

<template>
  <Dropdown v-if="url && habilitado" ref="dropdown">
    <Btn :size="size" type="primary" class="dropdown-toggle">
      <i class="fa fa-share"></i>
      Compartir
    </Btn>
    <template #dropdown>
      <li>
        <ShareNetwork
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :style="{ color: network.color }"
          :url="url"
          :title="title || ''"
          :description="description || ''"
          :quote="quote || ''"
          :hashtags="hashtags || ''"
          :twitterUser="twitterUser || ''"
        >
          <i :class="`fa fa-lg ${network.icon}`"></i>
          <span>{{ network.name }}</span>
        </ShareNetwork>
      </li>
    </template>
  </Dropdown>
</template>

<style scoped>
/deep/ .dropdown-menu {
  padding: 0;
  background-color: white;
}

/deep/ .btn-primary {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}
/* Corrige estilos en Sato */
body.paso3 .page-header .btn-primary i,
/* Corrige estilos en MapaPlus */
body.paso3 #container .page-header.page-header-title .btn-group .fa,
body.paso3 .page-header i {
  color: inherit;
  font-size: inherit;
}
body.paso3 #container .page-header.page-header-title .btn-group a {
  text-align: inherit;
}
/deep/ .btn-primary:focus,
/deep/ .btn-primary:hover {
  background-color: #204d74;
  border-color: #122b40;
}

#share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}

a[class^="share-network-"] {
  flex: none;
  color: #ffffff;
  color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0;
  text-decoration: none;
}

a[class^="share-network-"]:hover {
  background-color: #d3e1f5;
}

a[class^="share-network-"] .fah {
  color: rgba(0, 0, 0, 0.2);
  padding: 10px;
  flex: 0 1 auto;
}

a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1;
  font-weight: 500;
}

a.share-network-twitter {
  color: #1da1f2;
}

a.share-network-fakeblock {
  background-color: #41b883;
}
</style>